import React, { useState } from 'react';
import { Form, Input, Button, Card, Tabs, Select } from 'antd';
import { UserOutlined, LockOutlined, MailOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const LoginPage = () => {
  const [activeTab, setActiveTab] = useState('login');
  const [loading, setLoading] = useState(false);
  const { login, register } = useAuth();
  const navigate = useNavigate();

  const handleLogin = async (values) => {
    setLoading(true);
    const result = await login(values.username, values.password);
    setLoading(false);
    if (result.success) {
      const userInfo = JSON.parse(localStorage.getItem('user'));
      if (userInfo?.role === 'admin') {
        navigate('/admin');
      } else {
        navigate('/');
      }
    }
  };

  const handleRegister = async (values) => {
    setLoading(true);
    const result = await register(values.username, values.email, values.phone, values.password, values.role);
    setLoading(false);
    if (result.success) {
      navigate('/');
    }
  };

  const loginForm = (
    <Form onFinish={handleLogin}>
      <Form.Item
        name="username"
        rules={[{ required: true, message: '请输入用户名或邮箱' }]}
      >
        <Input
          prefix={<UserOutlined />}
          placeholder="用户名或邮箱"
          size="large"
        />
      </Form.Item>
      <Form.Item
        name="password"
        rules={[{ required: true, message: '请输入密码' }]}
      >
        <Input.Password
          prefix={<LockOutlined />}
          placeholder="密码"
          size="large"
        />
      </Form.Item>
      <Form.Item>
        <Button
          type="primary"
          htmlType="submit"
          loading={loading}
          block
          size="large"
        >
          登录
        </Button>
      </Form.Item>
    </Form>
  );

  const registerForm = (
    <Form onFinish={handleRegister}>
      <Form.Item
        name="username"
        rules={[
          { required: true, message: '请输入用户名' },
          { min: 3, message: '用户名至少3个字符' },
        ]}
      >
        <Input
          prefix={<UserOutlined />}
          placeholder="用户名"
          size="large"
        />
      </Form.Item>
      <Form.Item
        name="email"
        rules={[
          { required: true, message: '请输入邮箱' },
          { type: 'email', message: '请输入有效的邮箱地址' },
        ]}
      >
        <Input
          prefix={<MailOutlined />}
          placeholder="邮箱"
          size="large"
        />
      </Form.Item>
      <Form.Item
        name="phone"
        rules={[
          { required: true, message: '请输入手机号' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入有效的手机号' },
        ]}
      >
        <Input
          prefix={<UserOutlined />}
          placeholder="手机号"
          size="large"
        />
      </Form.Item>
      <Form.Item
        name="role"
        label="用户类型"
        rules={[{ required: true, message: '请选择用户类型' }]}
      >
        <Select placeholder="请选择用户类型" size="large">
          <Select.Option value="creator">创作者 - 接单创作AI短剧</Select.Option>
          <Select.Option value="publisher">发布者 - 发布制作任务</Select.Option>
        </Select>
      </Form.Item>
      <Form.Item
        name="password"
        rules={[
          { required: true, message: '请输入密码' },
          { min: 6, message: '密码至少6个字符' },
        ]}
      >
        <Input.Password
          prefix={<LockOutlined />}
          placeholder="密码"
          size="large"
        />
      </Form.Item>
      <Form.Item
        name="confirmPassword"
        dependencies={['password']}
        rules={[
          { required: true, message: '请确认密码' },
          ({ getFieldValue }) => ({
            validator(_, value) {
              if (!value || getFieldValue('password') === value) {
                return Promise.resolve();
              }
              return Promise.reject(new Error('两次输入的密码不一致'));
            },
          }),
        ]}
      >
        <Input.Password
          prefix={<LockOutlined />}
          placeholder="确认密码"
          size="large"
        />
      </Form.Item>
      <Form.Item>
        <Button
          type="primary"
          htmlType="submit"
          loading={loading}
          block
          size="large"
        >
          注册
        </Button>
      </Form.Item>
    </Form>
  );

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: '#0d0d12',
      }}
    >
      <Card
        title={<span style={{ color: '#00d4aa', fontSize: '24px', fontWeight: 'bold', textShadow: '0 0 20px rgba(0, 212, 170, 0.3)' }}>智影AI短剧创作系统</span>}
        style={{ 
          width: 400, 
          background: '#1a1a24',
          border: '1px solid #2a2a3a',
          borderRadius: 12,
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.5)'
        }}
        headStyle={{ borderBottom: '1px solid #2a2a3a', textAlign: 'center' }}
      >
        <Tabs
          activeKey={activeTab}
          onChange={setActiveTab}
          centered
          items={[
            {
              key: 'login',
              label: <span style={{ color: '#e8e8ec' }}>登录</span>,
              children: loginForm,
            },
            {
              key: 'register',
              label: <span style={{ color: '#e8e8ec' }}>注册</span>,
              children: registerForm,
            },
          ]}
        />
      </Card>
    </div>
  );
};

export default LoginPage;
